export const colors = {
  black: "#171717",
  white: "#FFFFFF",
  foreground: "#f8f8f8",
  lightBorder: "#dfdfdf",
  darkBorder: "#2e2e2e",
  lightIcons: "#707070",
  darkIcons: "#898989",
  lightIconHover: "#f3f3f3",
  darkIconHover: "#212121",
};
